import { resolveAppHost, resolvePublicApex } from '@/utils/cabinetHost';
import { DEFAULT_PREVIEW_SUBDOMAIN } from '@/config/publicEntryHosts';

/**
 * Apex hostname of the platform (боевой — `subster.ai`, WEB-2330). Admin panel
 * lives on `admin.<apex>`, project previews on `<projectSlug>.<apex>`.
 *
 * Override via `VITE_PUBLIC_APEX` env at build time when deploying to a
 * different public host (staging, custom domains, etc).
 */
export const PUBLIC_APEX: string = resolvePublicApex(
  import.meta.env.VITE_PUBLIC_APEX as string | undefined,
);

/**
 * WEB-2330 — хост кабинета. По умолчанию `app.<apex>`; стенд, где кабинет
 * живёт на самом апексе, задаёт `VITE_APP_HOST` равным `VITE_PUBLIC_APEX`.
 * Сюда же ведут ссылки на наши юридические страницы (`/privacy`, `/terms`,
 * `/health-data`). Правила — `utils/cabinetHost.ts`.
 */
export const APP_HOST: string = resolveAppHost(
  import.meta.env.VITE_APP_HOST as string | undefined,
  PUBLIC_APEX,
);

/**
 * WEB-2115 — имя поддомена ссылки предпросмотра: страница получателя живёт на
 * `preview.<apex>`. WEB-2793: имя вшито в код и одно на сервер, кабинет и
 * раздатчик (`frontend/Caddyfile`); переменной сборки для него нет —
 * расходиться на хостинге нечему. Правило хоста —
 * `config/publicEntryHosts.ts` (`isPreviewLinkHost`).
 */
export const PUBLIC_PREVIEW_SUBDOMAIN: string = DEFAULT_PREVIEW_SUBDOMAIN;
